<template>
  <b-row>
    <b-col
      v-for="(link, index) in rtsp"
      :key="index"
      lg="6"
      md="6"
      sm="12"
    >
      <br>
      <b-card
        no-body
      >
        <video
          :id="'video' + index"
          style="width:100%; height:auto; flex-direction: row;"
          muted
          playsinline
          autoplay
        />
        <b-card-text v-if="ISOnline[index] === 'Online'">
          <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style="overflow: auto;"
          >
            <rect
              width="48"
              height="48"
              rx="4"
              fill="url(#paint0_linear_431_10636)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_431_10636"
                x1="24"
                y1="0"
                x2="24"
                y2="48"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#99FBCA" />
                <stop
                  offset="0.404167"
                  stop-color="#00B058"
                />
              </linearGradient>
            </defs>
            <foreignObject
              width="100%"
              height="100%"
              y="9"
              style="text-align:center; font-size:20px; color: #fff;"
            >
              <h1> {{ index+1 }} </h1>
            </foreignObject>
          </svg>

          <span style="color: #fff;"> {{ name[index] }} </span>
        </b-card-text>

        <b-card-text v-else>
          <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              width="48"
              height="48"
              rx="4"
              fill="url(#paint0_linear_122_3)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_122_3"
                x1="24"
                y1="0"
                x2="24"
                y2="48"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FB9999" />
                <stop
                  offset="0.404167"
                  stop-color="#B00000"
                />
              </linearGradient>
            </defs>
            <foreignObject
              width="100%"
              height="100%"
              y="9"
              style="text-align:center"
            >
              <h1> {{ index+1 }} </h1>
            </foreignObject>
          </svg>

          {{ name[index] }}
        </b-card-text>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import Hls from 'hls.js'
import {
  BRow, BCol, BCard, BCardText,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
  },
  data() {
    return {
      rtsp: [],
      name: [],
      ISOnline: [],
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getRTSPCCTV()
    this.for()
    this.interval = setInterval(() => {
      this.getRTSPCCTV()
      this.for()
    }, 300000)
  },
  methods: {
    getRTSPCCTV() {
      axios
        .post('/getTableCountDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.rtspData = []
          this.rtsp = []
          this.rtspData = response.data
          this.rtspData.forEach(value => {
            this.rtsp.push(value.RTSP_URL)
            this.name.push(value.Camera_Desc)
            this.ISOnline.push(value.camconnect)
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    for() {
      setTimeout(() => this.rtsp.forEach((value, i) => {
        this.stream(value, i)
      }), 1000)
    },
    stream(value, i) {
      this.hls = new Hls({
        lowLatencyMode: true,
        autoreconnect: true,
      })
      const video = document.querySelector(`#video${i}`)
      const videoSrc = value
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoSrc
      } else if (Hls.isSupported()) {
        this.hls.loadSource(videoSrc)
        this.hls.attachMedia(video)
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
      }
    },
  },
}
</script>

<style>
</style>
